import { setSearchStats } from '@libs/analytics';

export function setSuggestedProductStats(searchTerm: string) {
    setSearchStats({ searchResults: 1, searchTerm, searchType: 'assisted', isSuggestedProduct: true });
}
